module.exports = __webpack_public_path__ + "static/media/phones_3@2x.4cf0ffe5.png";